import axios from 'axios';
import {backendHost} from '../../config';

export const putOperators = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/operators`, params);
};